import { StyledInputElement, StyledInputRoot } from "../../../../components/common/table/NumberInput.styles"
import { Checkbox, Typography } from "@mui/material"
import { ActionModule } from "../../../../types/actionModule/actionModule";
import { BaseIncentivationDataModel, BinaryIncentivationDataModel, ManualInputIncentivationDataModel, ScoreIncentivationDataModel } from "../../../../types/actionModule/incentivationDataModel";
import { IncentivationDataType } from "../../../../types/actionModule/incentivationDataType";
import { BaseRewardCalculationInformation, BinaryRewardCalculationInformation, ManualInputRewardCalculationInformation, ScoreRewardCalculationInformation } from "../../../../types/actionModule/rewardCalculationInformation";
import { StatusTypes } from "../../../../types/common";

export interface Props {
    actionModule: ActionModule
    isEditMode: boolean;
    incentivationData: BaseIncentivationDataModel | null;
    employeeStatus: StatusTypes;
    onChange: (updated: BaseRewardCalculationInformation) => void;
}

export default function IncentivationInputField(props: Props) {
    switch (props.actionModule.rewardCalculationType?.expectedIncentivationDataType) {
        case IncentivationDataType.Binary:
            return <BinaryIncentivationField
                incentivationData={props.incentivationData as BinaryIncentivationDataModel | null}
                onChange={props.onChange}
                employeeStatus={props.employeeStatus}
                isEditMode={props.isEditMode} />;
        case IncentivationDataType.ManualInput:
            return <ManualInputIncentivationField
                incentivationData={props.incentivationData as ManualInputIncentivationDataModel | null}
                isEditMode={props.isEditMode}
                employeeStatus={props.employeeStatus}
                onChange={props.onChange} />;
        case IncentivationDataType.Score:
            return <ScoreIncentivationField
                incentivationData={props.incentivationData as ScoreIncentivationDataModel | null}
                isEditMode={props.isEditMode}
                employeeStatus={props.employeeStatus}
                onChange={props.onChange} />;
        default:
            return <></>;
    }
}

interface BinaryIncentivationFieldProps {
    incentivationData: BinaryIncentivationDataModel | null;
    isEditMode: boolean;
    employeeStatus: StatusTypes;
    onChange: (updated: BinaryRewardCalculationInformation) => void;
}

function BinaryIncentivationField(props: BinaryIncentivationFieldProps) {
    return <Checkbox
        disabled={!props.isEditMode || props.employeeStatus !== StatusTypes.Active}
        checked={props.incentivationData?.isFulfilled ?? false}
        onChange={(e) => props.onChange({
            isFulfilled: e.target.checked,
            incentivationDataType: IncentivationDataType.Binary
        })} />
}

interface ManualInputIncentivationFieldProps {
    incentivationData: ManualInputIncentivationDataModel | null;
    isEditMode: boolean;
    employeeStatus: StatusTypes;
    onChange: (updated: ManualInputRewardCalculationInformation) => void;
}

function ManualInputIncentivationField(props: ManualInputIncentivationFieldProps) {
    if (props.isEditMode) {
        return <StyledInputRoot>
            <StyledInputElement
                disabled={props.employeeStatus !== StatusTypes.Active}
                className="numberInput"
                type="number"
                placeholder={"-"}
                value={props.incentivationData?.enteredReward}
                onChange={(e) => props.onChange({
                    enteredReward: Number(e.target.value),
                    incentivationDataType: IncentivationDataType.ManualInput
                })} />
        </StyledInputRoot>
    }
    else {
        return <Typography>{props.incentivationData?.enteredReward ?? "-"}</Typography>
    }
}

interface ScoreIncentivationFieldProps {
    incentivationData: ScoreIncentivationDataModel | null;
    isEditMode: boolean;
    employeeStatus: StatusTypes;
    onChange: (updated: ScoreRewardCalculationInformation) => void;
}

function ScoreIncentivationField(props: ScoreIncentivationFieldProps) {
    if (props.isEditMode) {
        return <StyledInputRoot>
            <StyledInputElement
                disabled={props.employeeStatus !== StatusTypes.Active}
                className="numberInput"
                type="number"
                placeholder={"-"}
                value={props.incentivationData?.score}
                onChange={(e) => props.onChange({
                    score: Number(e.target.value),
                    incentivationDataType: IncentivationDataType.Score
                })} />
        </StyledInputRoot>
    }
    else {
        return <Typography>{props.incentivationData?.score ?? "-"}</Typography>
    }
}
